export default {
    hasPeriod: (state) => !!(state.selectedPeriod && state.selectedPeriod.id),
    currentPeriod: (state) => state.selectedPeriod,
    availablePeriods: (state) => state.availablePeriods,
    isLoadingPeriods: (state) => state.loading,
    isSwitchingPeriod: (state) => state.switching,
    contextError: (state) => state.error
}

